import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_MOBILE_APP_RELEASES = createFcmDetails('mobile_app_releases', {
	owner: 'Mobile',
	context: 'Mobile App',
	description: `Specifies which versions of the mobile app should prompt the user to upgrade, and which ones should force them to upgrade.  We use this to ensure users are on current and working versions of the app.  When the user's app is brought to the foreground they call us to "register" their application and device information and we respond with a status that tells the app whether their current version is okay or needs to be updated.

To target a specific version and build, include both the version and build in the release object.  If the build is omitted then it will apply to all builds for that version.
`,
	template: {
		upgrade_recommended: [
			{
				version: '0.0.0',
				build: '0000',
			},
		],
		upgrade_required: [
			{
				version: '0.0.0',
				build: '0000',
			},
		],
	},
	import: false,
});
